import { useEffect } from 'react';

// Tipo ou formato sem componente correspondente. Existe para o aviso de "pronto" sair de dentro de
// um useEffect: o renderizarItem chamava onReady() durante a renderizacao, o que e setState no
// componente pai em plena fase de render — o React avisa e, em StrictMode, roda duas vezes.
export default function ItemNaoSuportado({ onReady }) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { onReady(); }, []);
    return null;
}
